var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllergen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.613,
    height: 13.613,
    viewBox: "0 0 13.613 13.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2802",
    "data-name": "Group 2802",
    transform: "translate(16322.2 17979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M9.307,2.5a6.807,6.807,0,1,0,6.807,6.807A6.813,6.813,0,0,0,9.307,2.5Zm0,12.137a5.331,5.331,0,1,1,5.331-5.331A5.339,5.339,0,0,1,9.307,14.637Z",
    transform: "translate(-16324.7 -17981.5)",
    fill: "#fff7b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M45.631,28.129a.734.734,0,0,0,.731-.731V24.031a.731.731,0,1,0-1.462,0v3.353A.737.737,0,0,0,45.631,28.129Z",
    transform: "translate(-16361.024 -17999.32)",
    fill: "#fff7b9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 0.903,
    cy: 0.903,
    r: 0.903,
    transform: "translate(-16316.296 -17970.432)",
    fill: "#fff7b9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergen);
export default __webpack_public_path__ + "static/media/allergen.c98d22c133176b662a56ef397be97b91.svg";
export { ForwardRef as ReactComponent };